import React, { Fragment } from "react";
import { Grid } from "@material-ui/core";
import _ from "lodash";
import styled from "styled-components";

import {
  ChildSectionTitle,
  SideLabelTextAreaWithRefInput
} from "../FormSectionComponents";

const StyledGrid = styled(Grid)`
  &&& {
    width:1200px;
  }
`;
class PartialReleaseChildSection extends React.Component {
  render() {
    const { isEditing } = this.props;

    return (
      <div id="covenants_section_partial_release">
        <ChildSectionTitle>Partial Release</ChildSectionTitle>
        <StyledGrid container alignItems="center" direction="column">

          <SideLabelTextAreaWithRefInput label="Notice" hasBorder placeholder="Notice" fieldName="covenants.notice" isDisabled={!isEditing} />
          <SideLabelTextAreaWithRefInput label="Conditions" hasBorder placeholder="Conditions" fieldName="covenants.conditions" isDisabled={!isEditing} />
          <SideLabelTextAreaWithRefInput label="Maximum Release" hasBorder placeholder="Maximum Release" fieldName="covenants.maximumRelease" isDisabled={!isEditing} />
          <SideLabelTextAreaWithRefInput label="Allocations" hasBorder placeholder="Allocations" fieldName="covenants.allocations" isDisabled={!isEditing} />
          <SideLabelTextAreaWithRefInput label="Misc." placeholder="Misc." fieldName="covenants.partialReleaseMisc" isDisabled={!isEditing} />

        </StyledGrid>
      </div>
    );
  }
}
export default PartialReleaseChildSection;
